import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-cricket-default',
    templateUrl: './sep/cricket_default/cricket-default.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class CricketDefaultComponent extends UnitsDistributionBase {
  // Used for:
  // CRICKET_CKT_MATCH_RESULT
  // CRICKET_CKT_OP_PARTNERSHIP
  // CRICKET_CKT_FST_SCR_SHOT
  // CRICKET_CKT_1INN_WICKET
  // CRICKET_CKT_2INN_WICKET
  // CRICKET_CKT_MATCH_SIXES
  // CRICKET_CKT_WICKETS_OU
  // CRICKET_CKT_PROP_RUNS_50
  // CRICKET_CKT_PROP_WICKETS
  // CRICKET_CKT_PROP_RUNS_20
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}